var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-index"},[_c('Navbar'),_c('v-main',{attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }